module.exports = "/packs/type-of-mokumoku-image-61dadff07159d507ab74b270026b8529.png";